module.exports = __webpack_public_path__ + "img/protection.80346555.svg";